import { Link } from "react-router-dom";
import { useMedia } from "../../media/MediaContext";
import YouTubeSection from "../components/blog/YouTubeSection";
export default function BookShortsPage() {
  const { config, loading, error, refresh } = useMedia();
  return <div className="blogPageContainer">
    {loading ? <p role="status">Loading…</p> : error ? <div role="alert"><p>{error}</p><button onClick={refresh}>Try again</button></div> : config?.blog.videosEnabled ? <YouTubeSection title="Author Videos & Shorts" preview={false} /> : <><h1>Page unavailable</h1><p>This page is currently turned off.</p></>}
    <p><Link to="/blog">Back to blog & videos</Link></p>
  </div>;
}
